export const estimatedArrival = (theme) => ({
    root: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(1),
    },
    container: {
        maxWidth: "320px",
        backgroundColor: theme.customPalette.neutralGr02,
        padding: "20px 24px",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "unset",
        },
    },
});
